exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".doses{padding:15px}.doses .dose{margin-bottom:15px;position:relative}.doses .dose .add-dose{text-align:center}.doses .dose a{color:inherit;text-decoration:none;cursor:pointer}.doses .dose .delete-button-icon{position:absolute;top:15px;right:15px;color:#e96f6f;cursor:pointer;font-size:1.5em}.doses .dose .delete-button-icon:hover{color:#f79494}.doses .subtitle{font-weight:400;color:#999}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/DoseList/DoseList.scss
// module id = 587
// module chunks = 0